module.exports = __webpack_public_path__ + "static/media/181CO201.14e7c4a6.jpg";